















import {Component, Prop, Vue} from "vue-property-decorator";
@Component({})
export default class SeoText extends Vue {
    @Prop({default:true}) required!:boolean;
    @Prop({}) value!:string;
    @Prop({default:"12"}) md!:string;
    @Prop({default:""}) pattern!:string;
    @Prop({default:false}) disabled!:boolean;
    @Prop({default:""}) extPattern!:string;
    rules:any = [];
    createUrl(){
        return this.$store.getters.siteUrl+this.pattern+this.$helper.seoUrl(this.value)+this.extPattern
    }
    updateValue (value:string) {
        //this.$helper.seoUrl()
        this.$emit('input', value)
    }
    goUrl(){
        console.log("gourl");
        window.open(this.createUrl(),"_blank");
    }
    created(){
        if(this.required === true){
            this.rules.push((v: any) => !!v || 'Zorunlu.');
        }
    }

}
